import { ProjectTreeNodeT } from "components/project/layers/hooks";

import OrganizationFolderNode from "./OrganizationFolderNode";
import OrganizationRootNode from "./OrganizationRootNode";
import OrganizationShapefileNode from "./OrganizationShapefileNode";

type OrganizationTreeNodeManagerPropsT = {
  node: ProjectTreeNodeT;
  setSelectedShapefile: (shapefile: ProjectTreeNodeT) => void;
};

export function OrganizationTreeNodeManager(props: OrganizationTreeNodeManagerPropsT) {
  const { node, setSelectedShapefile } = props;

  if (node.type === "root") {
    return <OrganizationRootNode node={node} />;
  } else if (node.type === "shapefile") {
    return (
      <OrganizationShapefileNode
        node={node}
        setSelectedShapefile={setSelectedShapefile}
      />
    );
  } else if (node.type === "node") {
    return <OrganizationFolderNode node={node} />;
  } else {
    return null;
  }
}
